import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../exercise1/Exercise1Failed.css"; 

const Exercise10Failed = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Retrieve accuracy scores from navigation state
  const comprehensionAccuracy = location.state?.comprehensionAccuracy || 0;
  const memoryAccuracy = location.state?.memoryAccuracy || 0;

  const handleRetry = () => {
    navigate("/exercise10intro");
  };

  return (
    <div className="exercise1-failed-container">
      <div className="failed-content">
        <h1>Let's give it another go. Tap below whenever you're ready!</h1>
        <p>
          This time, make sure to breathe properly and stay focused.  
          Take your time and try again!
        </p>

        {/* Display user’s comprehension and memory accuracy */}
        <div className="accuracy-section">
          <p><strong>Your Comprehension Accuracy:</strong> {comprehensionAccuracy.toFixed(1)}%</p>
          <p><strong>Your Memory Accuracy:</strong> {memoryAccuracy.toFixed(1)}%</p>
          <p>You need **75% or higher** in both to move on to the next level.</p>
        </div>

        <button className="retry-button" onClick={handleRetry}>
          Try Again
        </button>
      </div>
    </div>
  );
};

export default Exercise10Failed;
